import React from 'react';
import './LinkPreview.css';

/**
 * Miniatura da prévia de link (1200×627), igual à que o LinkedIn e o Teams mostram:
 * a capa enviada ou, sem capa, a capa gerada com o tema e o título (a mesma do og.png do backend).
 */
export function LinkPreviewThumb({ article, className = '' }) {
  const tag = (article.tags || [])[0];
  const tagName = typeof tag === 'string' ? tag : tag?.name;
  if (article.coverUrl) {
    return (
      <span className={`lp-thumb has-image ${className}`}>
        <img src={article.coverUrl} alt="" />
      </span>
    );
  }
  return (
    <span className={`lp-thumb ${className}`} aria-hidden="true">
      <span className="lp-thumb__brand"><b>&lt;</b>StudySpace<b>/&gt;</b></span>
      <span className="lp-thumb__foot">
        {tagName && <span className="lp-thumb__tag">#{tagName.replace(/\s+/g, '')}</span>}
        <span className="lp-thumb__title">{article.title || 'Título do artigo'}</span>
      </span>
    </span>
  );
}

/** Texto que vai na prévia: o escrito para ela ou, se vazio, o subtítulo. */
export function previewDescription(article) {
  return (article.previewText || '').trim() || (article.subtitle || '').trim() || 'Artigo no StudySpace';
}

/** Abre o Post Inspector do LinkedIn, que relê a página e renova a prévia guardada (~7 dias). */
export function linkedInInspectorUrl(url) {
  return `https://www.linkedin.com/post-inspector/inspect/${encodeURIComponent(url)}`;
}
